import { render, staticRenderFns } from "./technicalAdvice.vue?vue&type=template&id=e7ee22d6&scoped=true"
import script from "./technicalAdvice.vue?vue&type=script&lang=js"
export * from "./technicalAdvice.vue?vue&type=script&lang=js"
import style0 from "./technicalAdvice.vue?vue&type=style&index=0&id=e7ee22d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ee22d6",
  null
  
)

export default component.exports